module.exports = __webpack_public_path__ + "img/hc_pro_one_5.81627fa4.jpg";